

import { Component, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";
import moment from 'moment-timezone';

import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/common";
const commonState = namespace("Common");

import "@/store/modules/forms/form10";
const form10State = namespace("Form10");


import { form10DataInfoType, form10PartiesInfoType } from '@/types/Information/Form10';
import { chambersHearingJsonInfoType, partiesDataJsonDataType } from '@/types/Information/json';

import AddPartyForm from './AddPartyForm.vue';
import AddJudgeForm from './AddJudgeForm.vue';
import AddPartyModal from './AddPartyModal.vue';
import { hearingLocationsInfoType } from '@/types/Common';
import {justiceNames} from '@/components/utils/JusticeName';

@Component({
    components:{        
        AddJudgeForm,
        AddPartyForm,
        AddPartyModal        
    }
})
export default class Form10StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @commonState.State
    public hearingLocationsInfo!: hearingLocationsInfoType[];

    @form10State.State
    public currentOrder: chambersHearingJsonInfoType;

    @form10State.State
    public form10Info: form10DataInfoType;

    @form10State.Action
    public UpdateForm10Info!: (newForm10Info: form10DataInfoType) => void  
    
    @form10State.State
    public currentOrderSingleJusticeId: string;

    @form10State.Action
    public UpdateCurrentOrderSingleJusticeId!: (newCurrentOrderSingleJusticeId: string) => void
    
    dataReady = false;
    updated=0;  
  
    addRespondentFormColor = 'court';
    AddNewRespondentForm = false;

    addAppellantFormColor = 'court';
    AddNewAppellantForm = false;

    partyNames: form10PartiesInfoType[] = [];

    addJudgeNamesFormColor = 'court';
    AddNewJudgeNamesForm = false;
    latestEditJudgeNamesData;
    isEditJudgeNamesOpen = false;

    hearingLocationList: string[] = [];
    otherHearingLocationList: string[] = [];
    hearingLocation = "";
    otherHearingLocation = "";

    partyToEdit = {} as form10PartiesInfoType;
    showPartyWindow = false
    isCreate = true
    partyType = ''


    yesNoOptions = [
        {text: 'Yes', value: true},
        {text: 'No', value: false}
    ]; 

    partyFields = [
        { key:'organization', label:'Party Type', thClass: 'text-white bg-court', thStyle: '', sortable:false }, 
        { key:'name', label:'Party Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'counselName', label:'Counsel Name', thClass: 'text-white bg-court', thStyle: '',  sortable:false  },
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false }        
    ]

    judgeFields = [
        { key:'name', label:'Name', thClass:'text-white bg-court', thStyle: 'font-size: 1rem;', sortable:false },
        { key:'other',label:'', thClass:'text-white bg-court', thStyle: 'font-size: 1rem;', sortable:false},         
        { key:'edit', label:'', thClass: 'text-white bg-court', sortable:false}
    ]

    applicationList = [
        'adjournment',
        'adducing fresh or new evidence',
        'to consolidate or have appeals heard together',
        'directions',
        'dismissal of appeal in chambers',
        'dismissal (other)',
        'extend time to file books or documents',
        'extend time to appeal or cross-appeal',
        'intervener status',       
        'payment of security',
        'quashing an appeal or raising a preliminary objection',
        'reinstate appeal that is dismissed as abandoned',
        'remove appeal from inactive list',       
        'varying or cancelling an order of the registrar'
    ];

    state = { 
        appellantsInfo: null,
        respondentsInfo: null,
        judgeNames: null,        
        hearingDate: null,
        hearingLocation: null,
        hearingLocationOther: null,     
        dateOfJudgement: null,
        judgmentReserved: null,
        judgmentReservedDate:null,
        reasonsIndicated: null,
        reasonsDate: null,
        applicationFor: null,
        applicationForOther: null,
        ordersJusticeMake: null,
        filingParties: null,
        appearingParties: null,
        otherOrders: null,
        furtherOrders: null,
        
    }

    justiceNameOptions = [];
    created(){
        this.justiceNameOptions = justiceNames
    }

    mounted() {
        this.dataReady = false;        
        this.extractInfo();              
    }
    
    public extractInfo(){
        
        this.extractHearingLocations()

        if(this.currentOrderSingleJusticeId){
            this.getForm10Data();
           
        } else { 

            const form10Data = this.form10Info;            
            form10Data.version = this.$store.state.Application.version;

            form10Data.judgeNames = [];
            form10Data.appellants = this.partiesJson.appellants
            form10Data.respondents = this.partiesJson.respondents
            form10Data.formSevenNumber = this.fileNumber; 
            form10Data.appearingParties = [];
            form10Data.applicationFor= [];
            form10Data.applicationForOther='';
            form10Data.filingParties = [];           
            form10Data.chambersHearing = this.currentOrder;
            this.UpdateForm10Info(form10Data);            
            this.revaluateForm10Data()
            this.extractJudgeName()
            this.initHearingLocation()
            this.saveForm(true);
        }          
    }

    public extractJudgeName(){
        const currentOrder = this.form10Info.chambersHearing
        const judgeName = currentOrder && currentOrder.JudgeLastName? (
            (currentOrder.JudgeSalutation? currentOrder.JudgeSalutation+' ':'Justice ')+
            (currentOrder.JudgeLastName)
        ).trim() : ''

        if(judgeName){
            const justiceIndex = justiceNames.findIndex(name=> name.toLowerCase().includes(judgeName.toLowerCase()))
            if(justiceIndex>-1){
                this.form10Info.judgeNames=[{name:justiceNames[justiceIndex], other:'', text:justiceNames[justiceIndex]}]                
            }
            else{
                this.form10Info.judgeNames=[{name:'Other', other:judgeName, text:judgeName}]                
            }
            //DATE
            this.form10Info.hearingDate = currentOrder.JudgmentDate? currentOrder.JudgmentDate.slice(0,10) : currentOrder.ScheduleDate.slice(0,10)           
            //LOCATION
            const locationIndex = this.hearingLocationsInfo.findIndex(location => location.name == currentOrder.Location)
            if(locationIndex>-1)
                this.form10Info.hearingLocation = this.hearingLocationsInfo[locationIndex]
        }
        else{
            this.form10Info.judgeNames=[]
        }
        this.UpdateForm10Info(this.form10Info);
    } 

    public extractHearingLocations(){
        this.hearingLocationList = [];
        
        for (const hearingLocation of this.hearingLocationsInfo){
            if (hearingLocation.other)
                this.otherHearingLocationList.push(hearingLocation.name);
            else 
                this.hearingLocationList.push(hearingLocation.name);                
        }
        this.hearingLocationList.push('Other');
    }
    
    public initHearingLocation(){
        this.hearingLocation = this.form10Info.hearingLocation?.name
        if(this.otherHearingLocationList.includes(this.hearingLocation)){
            this.hearingLocation ='Other'
            this.otherHearingLocation = this.form10Info.hearingLocation.name
        }
    }

    public updateHearingLocation(){ 
              
        const form10 = this.form10Info;       
        form10.hearingLocation = {} as hearingLocationsInfoType;
       
        if (this.hearingLocation == 'Other' && this.otherHearingLocation.length > 0){
            form10.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.otherHearingLocation)[0]
        } else if (this.hearingLocation != 'Other') {
            form10.hearingLocation = this.hearingLocationsInfo.filter(location => location.name == this.hearingLocation)[0]
        }  
        
        this.UpdateForm10Info(form10);
        this.recheckStates()
    }

    public revaluateForm10Data(){

        const form10Data = this.form10Info;

        for (const respondent of form10Data.respondents){
            if (respondent.firstName && respondent.lastName){                    
                respondent.isOrganization = false;
            } else if (respondent.organization){
                respondent.isOrganization = true;
            }
            if(respondent.solicitor?.counselFirstName && respondent.solicitor?.counselLastName)
                respondent.counselName = respondent.solicitor.counselFirstName+' '+respondent.solicitor.counselLastName                          
            respondent.responding = true;
        }

        for (const applicant of form10Data.appellants){
            if (applicant.firstName && applicant.lastName){
                applicant.isOrganization = false;
            } else if (applicant.organization){
                applicant.isOrganization = true;
            }
            if(applicant.solicitor?.counselFirstName && applicant.solicitor?.counselLastName)
                applicant.counselName = applicant.solicitor.counselFirstName+' '+applicant.solicitor.counselLastName             
            applicant.responding = false;
        }

        const appellants = form10Data.appellants.map(resp=>resp.name)
        const respondents = form10Data.respondents.map(resp=>resp.name)
        form10Data.appellantNames = appellants.join(', ');
        form10Data.respondentNames = respondents.join(', ');

        this.partyNames = [...form10Data.appellants, ...form10Data.respondents]
        this.UpdateForm10Info(form10Data);
    }

    public getForm10Data() {        
       
        this.$http.get('/form10/forms/'+this.currentOrderSingleJusticeId)
        .then((response) => {
            if(response?.data?.data){
                const form10Data = response.data.data
                this.UpdateForm10Info(form10Data);
                this.revaluateForm10Data();
                this.clearStates();
                this.initHearingLocation()           
            }                
        },(err) => {
            console.log(err)        
        });      
    }

    public clearStates(){
        this.state = {
            appellantsInfo: null,
            respondentsInfo: null,
            judgeNames: null,        
            hearingDate: null,
            hearingLocation: null,
            hearingLocationOther: null,     
            dateOfJudgement: null,      
            judgmentReserved: null,
            judgmentReservedDate:null,
            reasonsIndicated: null,
            reasonsDate: null,
            applicationFor: null,
            applicationForOther: null,
            ordersJusticeMake: null,
            filingParties: null,
            appearingParties: null,
            otherOrders: null,
            furtherOrders: null
        }
        this.dataReady = true; 
    }

    public recheckStates(dontFindInvalidFields?){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates(dontFindInvalidFields)
                return 
            }
        }
    }

    public checkStates(dontFindInvalidFields?){  
        
        this.state.appellantsInfo = this.form10Info.appellants?.length>0? null :false;
        this.state.respondentsInfo = this.form10Info.respondents?.length>0? null :false;            
        this.state.judgeNames = this.form10Info.judgeNames?.length>0? null :false;
        this.state.hearingDate = this.form10Info.hearingDate? null: false;
        
        this.state.hearingLocation =  this.hearingLocation? null :false
        this.state.hearingLocationOther =  this.hearingLocation=='Other' && !this.otherHearingLocation? false :null
        
        this.state.dateOfJudgement = this.form10Info.dateOfJudgement? null: false;
        
        this.state.judgmentReserved = this.form10Info.judgmentReserved == true || this.form10Info.judgmentReserved ==false? null :false; 
        this.state.judgmentReservedDate = this.form10Info.judgmentReserved && !this.form10Info.judgmentReservedDate? false:null;
        
        this.state.reasonsIndicated = this.form10Info.reasonsIndicated == true || this.form10Info.reasonsIndicated ==false? null :false; 
        this.state.reasonsDate = this.form10Info.reasonsIndicated && !this.form10Info.reasonsDate? false: null;
        
        this.state.applicationFor = this.form10Info.applicationFor?.length>0? null :false
        this.state.applicationForOther = this.form10Info.applicationFor?.includes('other') && !this.form10Info.applicationForOther? false :null

        this.state.ordersJusticeMake = this.form10Info.ordersJusticeMake? null :false

        this.state.filingParties = this.form10Info.filingParties?.length>0? null :false;
        this.state.appearingParties = this.form10Info.appearingParties?.length>0? null :false;
        
        this.state.otherOrders = this.form10Info.otherOrders == true || this.form10Info.otherOrders ==false? null :false;
        this.state.furtherOrders = this.form10Info.otherOrders == true && !this.form10Info.furtherOrders? false :null

        if(dontFindInvalidFields == true) return true

        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }
        }
        return true            
    } 

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form10/forms';

        if (this.currentOrderSingleJusticeId){
            method = 'put';
            url = '/form10/forms/'+this.currentOrderSingleJusticeId;
            const form10Data = this.form10Info;            
            this.UpdateForm10Info(form10Data);

            if (!draft && !this.checkStates()){                               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form10Info,
                    type:'Form10',
                    description:'Order of a single justice'
                }
            }
            this.saveInfo(options, draft);

        } else {
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form10Info,
                    type:'Form10',
                    description:'Order of a single justice'
                }
            }
            this.saveInfo(options, draft);
        }
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentOrderSingleJusticeId(response.data.file_id); 
                    }

                    this.clearStates();                                     
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;                
            })
    }

    public addNewRespondent(){
        this.state.respondentsInfo = null
        this.partyToEdit = {} as form10PartiesInfoType
        this.partyType = 'Respondent'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editRespondent(data) {
        this.partyToEdit = data.item
        this.partyType = 'Respondent';
        this.isCreate = false;
        this.showPartyWindow = true;
    }

    public removeRespondent(data){ 
        const form10Data = this.form10Info;       
        form10Data.respondents.splice(data.index,1);
        form10Data.respondentNames = form10Data.respondents.map(resp=>resp.name).join(', ');
        this.partyNames = [...form10Data.appellants, ...form10Data.respondents]
        this.somePartiesChanged()
        this.UpdateForm10Info(form10Data);
        this.updated ++;        
    }

    public addNewAppellant(){
        this.state.appellantsInfo = null
        this.partyToEdit = {} as form10PartiesInfoType
        this.partyType = 'Appellant'
        this.isCreate = true;
        this.showPartyWindow = true;        
    }

    public editAppellant(data) {
        this.partyToEdit = data.item
        this.partyType = 'Appellant';
        this.isCreate = false;
        this.showPartyWindow = true;        
    }

    public removeAppellant(data){   
        const form10Data = this.form10Info;       
        form10Data.appellants.splice(data.index,1); 
        form10Data.appellantNames = form10Data.appellants.map(resp=>resp.name).join(', ');
        this.partyNames = [...form10Data.appellants, ...form10Data.respondents]        
        this.somePartiesChanged()
        this.UpdateForm10Info(form10Data);
        this.updated ++;        
    }

    public partyChanged(partyCreated){
        if(partyCreated){
            const form10Info = this.form10Info
            const party = JSON.parse(JSON.stringify(this.partyToEdit))
            if(this.partyType == 'Appellant'){
                form10Info.appellants.push(party);
            }
            else if(this.partyType =='Respondent'){
                form10Info.respondents.push(party);
            }
            this.UpdateForm10Info(form10Info)
        }
        this.revaluateForm10Data();
        this.showPartyWindow = false;
        this.somePartiesChanged() 
        this.updated++;
    }

    public addNewJudgeNames(){
        if(this.isEditJudgeNamesOpen){            
            this.addJudgeNamesFormColor = 'danger'
        }else{
            this.state.judgeNames = null;
            this.AddNewJudgeNamesForm = true;            
        }
    }

    public editJudgeNames(data) {
        // console.log(data)
        if(this.AddNewJudgeNamesForm || this.isEditJudgeNamesOpen){            
            this.addJudgeNamesFormColor = 'danger';                     
        }else if(!this.isEditJudgeNamesOpen && !data.detailsShowing){
            //console.log(data);
            data.toggleDetails();
            this.isEditJudgeNamesOpen = true;
            this.latestEditJudgeNamesData = data;            
        }   
    }

    public modifyJudgeNames(isCreateJudgeNames: boolean, newJudgeName: string, index: number, otherName){        

        const form10Data = this.form10Info;

        if (isCreateJudgeNames){           
            form10Data.judgeNames.push({name: newJudgeName, other: otherName, text: (otherName?otherName:newJudgeName) })            
        } else {                    
            form10Data.judgeNames[index] = {name: newJudgeName, other: otherName, text: (otherName?otherName:newJudgeName) };        
        }
        this.UpdateForm10Info(form10Data)
        this.closeJudgeNamesForm();
        this.updated ++;
    }

    public removeJudgeNames(data){ 
        const form10Data = this.form10Info;       
        form10Data.judgeNames.splice(data.index,1);        
        this.UpdateForm10Info(form10Data);
        this.updated ++;        
    }

    public closeJudgeNamesForm() {                     
        this.AddNewJudgeNamesForm= false; 
        this.addJudgeNamesFormColor = 'court'
        if(this.isEditJudgeNamesOpen){
            this.latestEditJudgeNamesData.toggleDetails();
            this.isEditJudgeNamesOpen = false;
        } 
        this.recheckStates()
    }

    public allowedDates(date){
        const day = moment().startOf('day').format('YYYY-MM-DD');
        return (date < day);           
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form10"}) 
    }

    public somePartiesChanged(){
        this.form10Info.filingParties=[]
        this.form10Info.appearingParties=[]
        this.updated++;
    }
    
    public filingPartiesChanged(){
        this.form10Info.appearingParties=[]
        this.updated++;
    }

    public getCounselParty(party){

        if(party.counselName){
            const counsel: form10PartiesInfoType = JSON.parse(JSON.stringify(party))
            counsel.isCounsel = true
            counsel.name = counsel.counselName+', counsel for '+counsel.name
            return counsel
        }        
        return party
    }


}
